import React, { useState, useEffect, useRef } from "react";
import {
  Image,
  Badge,
  Alert,
  Button,
  Popover,
  Card,
  Container,
  OverlayTrigger,
  InputGroup,
  Dropdown,
  Form,
  Modal,
} from "react-bootstrap";
import Select from "react-select";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import bhareeLogo from "../../assets/images/bhareeLogo.png";
import shopping_img from "../../assets/images/shopping_img.png";
import "./layout.css";
import { logoutUser } from "../../actions/auth.actions";

import { AcountIcon, BurgerMenu, DropDownArrowIcon } from "../../assets/svg/svg-icons";
import {
  getApi,
  getGuestJWTToken,
  markNotificationsAsRead,
  markSingleNotificationsAsRead,
  renewGuestJWTToken,
} from "../../actions/structure.action";
import isEmpty from "../../utils/is-Empty";
import CustomOffCanvas from "../common/CustomOffCanvas";
import BuyerAuth from "../auth/BuyerAuth";
import { appConstants, store, stringConstants } from "../../helpers";
import { toast } from "react-toastify";
import PageSpinner from "../common/PageSpinner";
import { BHAREE_BASE_URL_LOCAL } from "../../config/config.url";
import axios from "axios";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { getRecaptchaToken } from "../../utils/getReCaptchta";

import CustomModalWrapV2 from "../common/CustomModalWrapV2";
import Address from "../AdminPanel/common/Address";

const Navbar = () => {
  const {
    auth,
    cart,
    bhareeAdminBasicTable,
    checkEmailVerified,
    unreadNotifications,
    brands,
    addresses,
    guestJWTToken,
  } = useSelector((state) => {
    return state;
  });

  const [pageLoading, setPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showAboutUsMenu, setShowAboutUsMenu] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const queryParamsDistrict = queryParams.get("district");

  const handleAboutUsMenuClose = () => setShowAboutUsMenu(false);
  const handleAboutUsMenuShow = () => setShowAboutUsMenu(true);

  const [notifications, setNotifications] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const intervalRef = useRef(null);
  const guestTokenIntervalRef = useRef(null);

  const [allDistricts, setAllDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [addressModalShow, setAddressModalShow] = useState(false);
  const [defaultAddressDistrict, setDefaultAddressDistrict] = useState("");
  const [isAddressModalReady, setIsAddressModalReady] = useState(false);

  let options = {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.jwtToken}`,
    },
  };

  const { executeRecaptcha } = useGoogleReCaptcha();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaCreatedAt, setCaptchaCreatedAt] = useState(null);

  const handleNotificationCardClick = (notificationId) => {
    const notificationData = notifications.find((el) => el.id === notificationId);

    // If notification is related to order status
    if (notificationData?.notification_type === "ORDER_STATUS") {
      if (!isEmpty(notificationData?.data_object)) {
        const orderDataObj = JSON.parse(notificationData?.data_object);
        if (!isEmpty(orderDataObj)) {
          markSingleNotificationsAsRead(dispatch, notificationId);
          handleToggle(false);
          setTimeout(() => {
            window.location.href = `/order/${orderDataObj?.id}`;
          }, 500);
        }
      }
    }
    // If notification is related to enquiry status
    else if (notificationData?.notification_type === "ENQUIRY_STATUS") {
      const enquiryDataObj = JSON.parse(notificationData?.data_object);
      if (!isEmpty(enquiryDataObj)) {
        markSingleNotificationsAsRead(dispatch, notificationId);
        handleToggle(false);
        setTimeout(() => {
          window.location.href = `/enquiry/${enquiryDataObj?.enquiry_id}`;
        }, 500);
      }
    }
    // If notification is related to new offer
    else if (notificationData?.notification_type === "LIVE_OFFER") {
      const productVariantObj = JSON.parse(notificationData?.data_object);
      if (!isEmpty(productVariantObj)) {
        markSingleNotificationsAsRead(dispatch, notificationId);
        handleToggle(false);
        setTimeout(() => {
          window.location.href = `/product/${productVariantObj?.id}`;
        }, 500);
      }
    }
  };

  const clearAllNotifications = () => {
    if (notifications && notifications.length > 0) {
      markNotificationsAsRead(dispatch).then((res) => {
        handleToggle(false);
        getApi("getUnreadNotifications", dispatch); // fetch immediately
      });
    }
  };

  const popover = (
    <Popover className="notifcations-popper " id="popover-basic">
      <Popover.Header as="div" className="d-flex justify-content-between align-items-center">
        <h5 className="m-0">Notifications</h5>

        {notifications.length > 0 && (
          <Button
            variant="link"
            className="p-0 m-0 text-decoration-none small text-white"
            onClick={clearAllNotifications}
          >
            Clear All
          </Button>
        )}
      </Popover.Header>
      <Popover.Body>
        <Container>
          {notifications.length > 0 ? (
            notifications.map((notif) => (
              <Card
                key={notif.id}
                className="mb-2 shadow-sm border-0 notification-card w-100"
                onClick={() => {
                  handleNotificationCardClick(notif.id);
                }}
              >
                <div className="p-2 text-start">
                  <Card.Title className="fs-6 mb-1 fw-semibold text-start w-100">
                    {notif.title}
                  </Card.Title>
                  <Card.Text className="text-muted small mb-0 text-start w-100">
                    {notif.description}
                  </Card.Text>
                </div>
              </Card>
            ))
          ) : (
            <p className="text-center text-muted">There are no new notifications</p>
          )}
        </Container>
      </Popover.Body>
    </Popover>
  );

  // 🔹 Function to start the 5-minute interval
  const startInterval = () => {
    if (intervalRef.current) return; // avoid multiple intervals
    getApi("getUnreadNotifications", dispatch); // fetch immediately
    intervalRef.current = setInterval(
      () => {
        getApi("getUnreadNotifications", dispatch);
      },
      5 * 60 * 1000,
    );
  };

  // 🔹 Function to clear the interval
  const clearIntervalIfExists = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // 🔹 Manage interval based on login status
  useEffect(() => {
    if (auth?.loggedIn) {
      startInterval();
    } else {
      clearIntervalIfExists();
    }

    return () => clearIntervalIfExists(); // cleanup on unmount
  }, [auth]);

  useEffect(() => {
    if (unreadNotifications?.data?.length > 0) {
      setNotifications(unreadNotifications?.data);
    } else {
      setNotifications([]);
    }
  }, [unreadNotifications]);

  const handleBellClick = () => {
    if (notifications.length > 0) {
    }
  };

  // 🔹 Handle popover show/hide
  const handleToggle = (nextShow) => {
    console.log("handleToggle: nextShow: ", nextShow);
    setShowPopover(nextShow);
    if (nextShow) {
      // Popover opened → pause API polling
      clearIntervalIfExists();
    } else {
      // Popover closed → resume API polling
      if (auth?.loggedIn) startInterval();
    }
  };

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 150) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  const isCaptchaExpired = () => {
    if (isEmpty(captchaToken)) return true; // no token → expired
    if (isEmpty(captchaCreatedAt)) return true; // no captcha → expired

    const now = Date.now();
    return now - captchaCreatedAt > 120000; // 2 minutes
  };

  const getGuestToken = async () => {
    if (!executeRecaptcha) {
      console.log("Recaptcha not yet available");
      return;
    }

    // Action name = "submit_guest_auth"
    const isCaptchaExpiredFlag = isCaptchaExpired();
    const token = isCaptchaExpiredFlag
      ? await getRecaptchaToken(executeRecaptcha, "submit_guest_auth")
      : captchaToken;

    if (isCaptchaExpiredFlag) {
      setCaptchaToken(token);
      setCaptchaCreatedAt(Date.now());
    }

    // Call your backend with captchaToken
    getGuestJWTToken(dispatch, token).then((res) => {
      // console.log("Guest JWT Token Response: ", res);
      if (res?.rawData?.success) {
        localStorage.setItem("guest_jwt_token", res?.rawData?.data?.guestToken);
      }
    });
  };

  // 🔹 Function to start the 10-minute interval
  const startGuestTokenInterval = () => {
    if (guestTokenIntervalRef.current) return; // avoid multiple intervals
    guestTokenIntervalRef.current = setInterval(
      () => {
        console.log("---- Renew Guest Token ----");
        renewGuestJWTToken(dispatch).then((res) => {
          console.log("Guest JWT Token Response: ", res);
          if (res?.rawData?.success) {
            localStorage.setItem("guest_jwt_token", res?.rawData?.data?.guestToken);
          }
        });
      },
      10 * 60 * 1000,
    );
  };

  // 🔹 Function to clear the guest token interval
  const clearGuestTokenIntervalIfExists = () => {
    if (guestTokenIntervalRef.current) {
      clearInterval(guestTokenIntervalRef.current);
      guestTokenIntervalRef.current = null;
    }
  };

  // 🔹 Manage guest token based on guest token
  useEffect(() => {
    // console.log("In Loop: ", guestJWTToken);
    if (!isEmpty(guestJWTToken) && !isEmpty(guestJWTToken?.data)) {
      startGuestTokenInterval();
    } else {
      clearGuestTokenIntervalIfExists();
    }

    return () => clearIntervalIfExists(); // cleanup on unmount
  }, [guestJWTToken]);

  useEffect(() => {
    setPageLoading(true);
    getGuestToken()
      .then(() => {
        setPageLoading(false);
      })
      .catch(() => {
        setPageLoading(false);
      });
  }, [executeRecaptcha]);

  useEffect(() => {
    // console.log("guestJWTToken: ", guestJWTToken);
    if (
      !isEmpty(guestJWTToken) &&
      !isEmpty(guestJWTToken?.data?.guestToken) &&
      guestJWTToken?.data?.renewal === false
    ) {
      setPageLoading(true);
      Promise.all([
        getApi("getRoles", dispatch),
        getApi("getRolesTypes", dispatch),
        getApi("getSellerTypes", dispatch),
        getApi("getAppConfig", dispatch),
        getApi("getGstStates", dispatch),
        new Promise((resolve) => {
          setTimeout(() => {
            getAllDistricts().then(resolve);
          }, 1000);
        }),
      ])
        .then(() => {
          setPageLoading(false); // hide mask
        })
        .catch(() => {
          setPageLoading(false); // still hide mask on error
        });
    }
  }, [guestJWTToken, dispatch]);

  useEffect(() => {
    setAddressModalShow(false);
    if (auth?.loggedIn && auth?.user?.role.role_name === appConstants.BUYER) {
      setPageLoading(true);
      Promise.all([
        getApi("getCart", dispatch),
        getApi("getBhreeAdminBasicTables", dispatch),
        getApi("getAddressess", dispatch),
        getApi("checkEmailVerified", dispatch),
      ])
        .then(() => {
          setPageLoading(false); // hide mask
        })
        .catch(() => {
          setPageLoading(false); // still hide mask on error
        });

      // Show the address modal if no addresses are present
      getApi("getAddressess", dispatch).then((res) => {
        console.log("ADDRESS API RES: ", res);
        if (res && res.rawData && res.rawData.success) {
          if (res.rawData.data.length === 0) {
            setAddressModalShow(true);
          } else {
            setAddressModalShow(false);
          }
        }
      });
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Find default address city from addresses and keep it in state
  useEffect(() => {
    // Handle default address
    if (auth && auth?.loggedIn && auth?.user?.role?.role_name !== stringConstants.ROLL_BHAREE) {
      if (!isEmpty(addresses?.data)) {
        const defaultAddress =
          addresses?.data?.find((a) => a.set_default === 1) || addresses?.data[0];
        setDefaultAddressDistrict(defaultAddress?.district);
      }
    }
  }, [addresses]);

  useEffect(() => {
    if (auth?.loggedIn && auth?.user?.role.role_name === appConstants.BUYER) {
      // console.log("checkEmailVerified data: ", checkEmailVerified);
      if (!isEmpty(checkEmailVerified) && !checkEmailVerified?.loading) {
        if (checkEmailVerified?.data?.email_verify_status === 0) {
          setErrorMessage(
            <>
              Your email is not verified. Please {clickHereToVerify()} to verify your email address.
            </>,
          );
        }
      }
    }
  }, [checkEmailVerified, auth]);

  useEffect(() => {
    if (!isEmpty(bhareeAdminBasicTable?.data) && !isEmpty(cart?.data)) {
      let count = 0;
      bhareeAdminBasicTable?.data?.paymentTypes.map((payment) => {
        if (!isEmpty(cart?.data[payment?.name]) && cart?.data[payment?.name]?.length > 0) {
          return (count = count + cart?.data[payment?.name]?.length);
        }
      });
      return setCartCount(cart?.data.cartCount);
    }
  }, [bhareeAdminBasicTable, cart?.data]);

  // Create a link to put it inside the top message for email verification
  const clickHereToVerify = () => {
    return (
      <Link
        variant="link"
        className="m-0 p-0"
        onClick={() => {
          setPageLoading(true);
          getApi("sendEmailVerificationLink", dispatch)
            .then((res) => {
              if (res?.rawData?.success) {
                toast.success("Verification link has been sent to your email address.");
              } else {
                toast.error("Failed to send verification link. Please try again.");
              }
            })
            .catch((err) => {
              toast.error("Failed to send verification link. Please try again.");
            })
            .finally(() => {
              setPageLoading(false);
            });
        }}
      >
        click here
      </Link>
    );
  };

  const homeRouteLinks = (
    <>
      {auth.loggedIn && (
        <>
          <Link
            className={`nav-item nav-link-color brand-hover ${
              pathname.includes("/account") ? "active white" : "no-active"
            }`}
            onClick={() => setShowAboutUsMenu(false)}
            to="/account"
          >
            {"Account"}
          </Link>
          <Link
            className={`nav-item nav-link-color  brand-hover ${
              pathname.includes("cart") ? "active" : "no-active"
            }`}
            onClick={() => setShowAboutUsMenu(false)}
            to="/cart"
          >
            {"Cart"}
          </Link>
          <Link
            className={`nav-item nav-link-color brand-hover no-active`}
            onClick={() => {
              // Logout user
              store.dispatch(logoutUser());
              // clear current classrom
              window.location.href = "/";
            }}
            to="#"
          >
            {"Logout"}
          </Link>
        </>
      )}
      {/* {!auth.loggedIn && (<BuyerAuth buttonText={"Login"} buttonClasses={"nav-item nav-link-color modal-login-btn"} />)} */}

      <Link
        className={`nav-item nav-link-color    brand-hover ${
          pathname.includes("brands") ? "active" : "no-active"
        }`}
        onClick={() => setShowAboutUsMenu(false)}
        to="/brands"
      >
        {"Brands"}
      </Link>
      <Link
        className={`nav-item nav-link-color    brand-hover ${
          pathname.includes("support") ? "active" : "no-active"
        }`}
        onClick={() => setShowAboutUsMenu(false)}
        to="/support"
      >
        {"Contact"}
      </Link>
      {auth?.user?.role?.role_name !== "BUYER" && (
        <div className="desktop-nav-item">
          <Link
            className={`nav-item nav-link-color white blackBg`}
            onClick={() => setShowAboutUsMenu(false)}
            to="/about-us/home"
          >
            {"Become a seller"}
          </Link>
        </div>
      )}
    </>
  );

  useEffect(() => {
    // ✅ First priority → URL param
    if (allDistricts && allDistricts.length > 0) {
      let selected = null;

      if (queryParamsDistrict) {
        selected = allDistricts.find(
          (o) => o.value.toLowerCase() === queryParamsDistrict.toLowerCase(),
        );
      }

      // ✅ Second priority → Local Storage
      if (!selected) {
        if (!isEmpty(localStorage.getItem("localSelectedDistrict"))) {
          selected = allDistricts.find(
            (o) =>
              o.value.toLowerCase() === localStorage.getItem("localSelectedDistrict").toLowerCase(),
          );
        }
      }

      if (!selected) {
        if (auth?.loggedIn && auth?.user?.role.role_name === appConstants.BUYER) {
          if (!isEmpty(defaultAddressDistrict)) {
            selected = allDistricts.find(
              (o) => o.value.toLowerCase() === defaultAddressDistrict.toLowerCase(),
            );

            if (isEmpty(localStorage.getItem("localSelectedDistrict"))) {
              localStorage.setItem("localSelectedDistrict", defaultAddressDistrict);
            }
          }
        }
      }

      // ✅ Fallback → Pune
      // if (!selected) {
      //   selected = options.find((o) => o.value === "Pune");
      // }

      setSelectedDistrict(selected || null);
    }
  }, [allDistricts, defaultAddressDistrict, queryParamsDistrict, auth]);

  const getAllDistricts = async () => {
    let apiURL = BHAREE_BASE_URL_LOCAL + "/api/getAllDistricts";

    try {
      const res = await axios.get(apiURL, {
        headers: {
          ...options.headers,
          "x-guest-token": `${localStorage.getItem("guest_jwt_token")}`,
        },
      });
      // console.log("Get All Districts Response: ", res);
      if (res.data.success) {
        // Convert API [{"district_name": "Adilabad"}, ...] → react-select format
        const options = res.data.data.map((item) => ({
          value: item.district_name,
          label: item.district_name,
        }));

        setAllDistricts(options);
      } else {
        console.error("Failed to fetch geo data:", res.data.message);
      }
    } catch (error) {
      console.error("Error fetching geo data:", error);
    }
  };

  const [showSearchPopup, setShowSearchPopup] = useState(false);
  const handleShow = () => setShowSearchPopup(true);
  const handleClose = () => setShowSearchPopup(false);
  const CitySearchModal = () => {
    return (
      <>
        {/* 🏙️ Modal Popup */}
        <Modal
          show={showSearchPopup}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          style={{ top: "5%" }} // push modal down a bit from top
        >
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Select District</Form.Label>
              <Select
                options={allDistricts}
                value={selectedDistrict}
                onChange={(val) => setSelectedDistrict(val)}
                isSearchable
                classNamePrefix="react-select-search"
                placeholder="Select District"
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                window.location.href = `/brands?district=${selectedDistrict.value}`;
              }}
            >
              Search
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  const logoAndSearch = (
    <>
      {pageLoading && <PageSpinner />}
      {CitySearchModal()}
      <nav className="navbar-section py-0">
        <div className="container navbar-container">
          <Link className="navbar-brand" to="/">
            <Image src={bhareeLogo} alt="bhareeLogo" />
          </Link>

          <div className="search-wrap desktop">
            <div className="w-full search-container ">
              <InputGroup className="align-items-center justify-content-end">
                {/* ✅ react-select replacing Dropdown */}
                <div className="district-select-wrapper">
                  <Select
                    options={allDistricts}
                    value={selectedDistrict}
                    onChange={(val) => setSelectedDistrict(val)}
                    isSearchable
                    classNamePrefix="react-select"
                    placeholder="Select District"
                  />
                </div>

                {/* ✅ search input */}
                {/* <Form.Control
                  className="search-box ms-0"
                  placeholder="Search Brands"
                  aria-label="Search Brands"
                /> */}

                {/* ✅ search button */}
                <Button
                  className="px-4 search-btn"
                  variant="outline-secondary"
                  style={{ height: "38px" }}
                  onClick={() => {
                    if (!isEmpty(selectedDistrict) && !isEmpty(selectedDistrict?.value)) {
                      localStorage.setItem("localSelectedDistrict", selectedDistrict?.value);
                      window.location.href = `/brands?district=${selectedDistrict?.value}`;
                    }
                  }}
                >
                  <i className="bi bi-search"></i>
                </Button>
              </InputGroup>
            </div>
          </div>
          {/* <div className="mobile link-warp">
            <div className="w-full search-container ">
              <InputGroup>
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic" className="search-dropdown">
                    {"Pune"}
                    <DropDownArrowIcon />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">{"Action"}</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">{"Another action"}</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">{"Something else"}</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </InputGroup>
            </div>
          </div> */}

          <div className="nav-icons">
            <div className="desktop-nav-item">
              <Link
                className="nav-item nav-link-color desktop"
                onClick={() => setShowAboutUsMenu(false)}
                to="/brands"
              >
                {"Brands"}
              </Link>
              <Link
                className="nav-item nav-link-color desktop"
                onClick={() => setShowAboutUsMenu(false)}
                to="/support"
              >
                {"Contact"}
              </Link>
              {auth.loggedIn ? (
                <Link
                  className="nav-item nav-link-color "
                  onClick={() => {
                    // Logout user
                    store.dispatch(logoutUser());
                    // clear current classrom
                    window.location.href = "/";
                  }}
                  to="#"
                >
                  {"Logout"}
                </Link>
              ) : (
                <BuyerAuth
                  buttonText={"Login"}
                  buttonClasses={"nav-item nav-link-color  modal-login-btn "}
                />
              )}
              {auth?.user?.role?.role_name !== "BUYER" && (
                <Link className="nav-item nav-link-color blackBg desktop" to="/about-us/home">
                  {"Become a seller"}
                </Link>
              )}
            </div>
            <Button
              variant="link"
              className="nav-item px-2 border-0 text-dark mobile mx-1"
              style={{ height: "38px" }}
              onClick={handleShow}
            >
              <i className="bi bi-search fs-5"></i>
            </Button>
            {auth.loggedIn && (
              <>
                <Link
                  className="nav-item nav-link-color"
                  to="/cart"
                  style={{ marginLeft: "0.7rem", marginRight: "0.7rem" }}
                >
                  <Image height={20} width={20} src={shopping_img} alt="social" />
                  {!isEmpty(cart?.data) && cart?.data?.cartCount > 0 && (
                    <sup>
                      <Badge bg="warning" className="cartBadge">
                        {cart?.data?.cartCount}
                      </Badge>
                    </sup>
                  )}
                </Link>
                <Link
                  className="nav-item nav-link-color"
                  to="/account"
                  style={{ marginLeft: "0.7rem", marginRight: "0.7rem" }}
                >
                  <AcountIcon />
                  {/* <Image height={20} width={20} src={profile_img} alt="social" /> */}
                </Link>
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  overlay={popover}
                  rootClose
                  show={showPopover}
                  onToggle={handleToggle}
                >
                  <Button
                    variant="light"
                    onClick={handleBellClick}
                    style={{
                      position: "relative",
                      padding: "6px",
                      border: "none",
                      background: "transparent",
                      fontSize: "24px",
                      marginTop: "5px",
                    }}
                  >
                    <i className="bi bi-bell"></i>
                    {notifications.length > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "0px",
                          minWidth: "18px",
                          height: "18px",
                          backgroundColor: "red",
                          color: "white",
                          borderRadius: "50%",
                          fontSize: "12px",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "2px",
                          lineHeight: "1",
                        }}
                      >
                        {notifications.length}
                      </span>
                    )}
                  </Button>
                </OverlayTrigger>
              </>
            )}
            <div className="mobile burger-menu-wrap">
              <CustomOffCanvas
                buttonContant={<BurgerMenu />}
                placement={"end"}
                className="aboutus-ofcanvas"
                backdropClassName="aboutus-backdrop"
                bodyBsPrefix="aboutus-ofcanvas-body"
                isOffCanvasOpen={showAboutUsMenu}
                OffcanvasShow={handleAboutUsMenuShow}
                OffcanvasClose={handleAboutUsMenuClose}
              >
                <div className="w-full about-mobile-menu ">{homeRouteLinks}</div>
              </CustomOffCanvas>
            </div>
          </div>
        </div>
        {errorMessage && (
          <Alert variant="danger" className="mb-0" style={{ borderRadius: 0, padding: "1px" }}>
            {errorMessage}
          </Alert>
        )}
      </nav>
      <div className="space"></div>
    </>
  );

  const aboutRouteLinks = (
    <>
      <Link
        className={`nav-item nav-link-color brand-hover ${
          pathname.includes("/about-us/home") ? "active white" : "no-active"
        }`}
        onClick={() => setShowAboutUsMenu(false)}
        to="/about-us/home"
      >
        {"Home"}
      </Link>
      <Link
        className={`nav-item nav-link-color  brand-hover ${
          pathname.includes("about-us/buyer") ? "active" : "no-active"
        }`}
        onClick={() => setShowAboutUsMenu(false)}
        to="/about-us/buyer"
      >
        {"Buyer"}
      </Link>

      {auth.loggedIn && auth?.user?.role?.role_name !== "BUYER" && (
        <Link
          className={`nav-item nav-link-color brand-hover ${
            pathname.includes("about-us/seller") ? "active" : "no-active"
          }`}
          onClick={() => setShowAboutUsMenu(false)}
          to="/about-us/seller"
        >
          {"Seller"}
        </Link>
      )}

      {auth?.user?.role?.role_name !== "BUYER" && (
        <Link
          className={`nav-item nav-link-color  brand-hover ${
            pathname.includes("about-us/become-a-seller") ? "active" : "no-active"
          }`}
          onClick={() => setShowAboutUsMenu(false)}
          to="/about-us/become-a-seller"
        >
          {"Become a seller"}
        </Link>
      )}

      <Link
        className={`nav-item nav-link-color    brand-hover ${
          pathname.includes("support") ? "active" : "no-active"
        }`}
        onClick={() => setShowAboutUsMenu(false)}
        to="/support"
      >
        {"Contact"}
      </Link>
      <div className="desktop-nav-item">
        <Link
          className={`nav-item nav-link-color white blackBg`}
          onClick={() => setShowAboutUsMenu(false)}
          to="/"
        >
          {"Shop Now"}
        </Link>
      </div>
    </>
  );

  const forAboutUs = (
    <nav className={`navbar-section  about-us ${scrolled ? "scrolled" : ""}`}>
      <div className="container navbar-container">
        <Link className="navbar-brand" to="/">
          <Image src={bhareeLogo} alt="bhareeLogo" />
        </Link>
        <div className="desktop w-full">
          <div className="w-full about-desktop-menu ">{aboutRouteLinks}</div>
        </div>
        <div className="mobile burger-menu-wrap">
          <CustomOffCanvas
            buttonContant={<BurgerMenu />}
            placement={"end"}
            className="aboutus-ofcanvas"
            backdropClassName="aboutus-backdrop"
            bodyBsPrefix="aboutus-ofcanvas-body"
            isOffCanvasOpen={showAboutUsMenu}
            OffcanvasShow={handleAboutUsMenuShow}
            OffcanvasClose={handleAboutUsMenuClose}
          >
            <div className="w-full about-mobile-menu ">{aboutRouteLinks}</div>
          </CustomOffCanvas>
        </div>
      </div>
    </nav>
  );

  return (
    <>
      {/* Address Modal */}
      {addressModalShow && (
        <CustomModalWrapV2
          isModalOpen={addressModalShow}
          showModal={() => setAddressModalShow(true)}
          closeModal={() => setAddressModalShow(false)}
          footerContent={
            !isEmpty(addresses?.data) && addresses?.data?.length > 0 ? (
              <Button onClick={() => setAddressModalShow(false)}>Close</Button>
            ) : null
          }
          showCloseButton={!isEmpty(addresses?.data) && addresses?.data?.length > 0 ? true : false}
          closeOnBackdrop={!isEmpty(addresses?.data) && addresses?.data?.length > 0 ? true : false}
          closeOnEsc={!isEmpty(addresses?.data) && addresses?.data?.length > 0 ? true : false}
          fullscreen="md-down"
          size="xl"
          centered
        >
          <Address />
        </CustomModalWrapV2>
      )}
      {!pathname.includes("panel") && (pathname.includes("about") ? forAboutUs : logoAndSearch)}
    </>
  );
};

export default Navbar;
